module.exports = __webpack_public_path__ + "static/media/IMG_6128_DH3.efc67446.jpg";